<template>
  <div class="c-heading">
    <h1 v-if="type == 'h1'">{{text}}</h1>
    <h2 v-if="type == 'h2'">{{text}}</h2>
    <h3 v-if="type == 'h3'">{{text}}</h3>
    <h4 v-if="type == 'h4'">{{text}}</h4>
    <h5 v-if="type == 'h5'">{{text}}</h5>
  </div>
</template>

<script>
export default {
  name: 'base-heading',

  props: {
    type: String,
    text: String,
  },
};
</script>

<style>
.c-heading {
}
</style>
